import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EncryptionService } from '../services/EncryptionService/encryption-service.service';
import { catchError, map, of, from, switchMap } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { WafService } from '../services/waf/waf.service';

export const PKeyGuard: CanActivateFn = () => {

  const encS: EncryptionService = inject(EncryptionService);
  const load: LoadingService = inject(LoadingService);
  const router: Router = inject(Router);
  const wafLoaderService = inject(WafService);
  
  // Primero cargamos el WAF, luego validamos la encriptación
  return from(wafLoaderService.ensureWafLoadedAndTokenAvailable()).pipe(
    switchMap((wafLoaded: boolean) => {
      if (!wafLoaded) {
        console.error('Error al cargar WAF');
        router.navigate(['']);
        load.reset();
        return of(false);
      }
      
      // Si WAF se cargó correctamente, procedemos con la validación de encriptación
      return encS.getInitData().pipe(
        map((isApproved: boolean) => {
          if (isApproved) return true;
          router.navigate(['']);
          load.reset();
          return false;
        }),
        catchError(error => {
          console.error('Error al obtener la llave:', error);
          router.navigate(['']);
          load.reset();
          return of(false);
        })
      );
    }),
    catchError(error => {
      console.error('Error en el guard:', error);
      router.navigate(['']);
      load.reset();
      return of(false);
    })
  );
};